import Vue from 'vue'
import Router from 'vue-router'
import index from '@/view/index'
import home from '@/view/home/home'
import about from '@/view/about/about'
import contact from '@/view/contact/contact-us'
import search from '@/view/search'
import report from '@/view/report'
import reportresult from '@/view/reportresult'
import reportresultimg from '@/view/reportresultimg'
import reportoldresult  from '@/view/reportoldresult'

import notices from '@/view/news/notices/notices'
import mediaCenter from '@/view/news/media-center/media-center'
import mediaCenterPage from '@/view/news/media-center/media-center-page'

import yDNATest from '@/view/projects/y-dna-test/y-dna-test'
import paternityTest from '@/view/projects/paternity-test/paternity-test'
import nPrenatalTest from '@/view/projects/n-prenata-test/n-prenata-test'
Vue.use(Router)

export default new Router({
  
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      redirect: '/home',
      children:[
        {
          path: '/home',
          name: 'home',
          component: home,
        },
        {
          path: '/search',
          name: 'search',
          component: search,
          meta:{
            title:'查詢驗證香港醫務檢測中心報告',
            keywords:'香港醫務檢測中心報告查询,香港醫務檢測中心報告,香港醫務檢測中心报告单查询',
            description:'查詢驗證香港醫務檢測中心報告,可上香港醫務檢測中心官网自助查詢,也可致電報告單上的電話,或郵件查詢,驗證報告或了解更多資訊,歡迎來電'
          }
        },
        {
          path: '/reportoldresult',
          name: 'reportoldresult',
          component: reportoldresult
        },
        {
          path: '/about',
          name: 'about',
          component: about
        },
        {
          path: '/contact',
          name: 'contact',
          component: contact
        },
        {
          path: '/yDNATest',
          name: 'yDNATest',
          component: yDNATest
        },
        {
          path: '/paternityTest',
          name: 'paternityTest',
          component: paternityTest
        },
        {
          path: '/nPrenatalTest',
          name: 'nPrenatalTest',
          component: nPrenatalTest
        },
        {
          path: '/notices',
          name: 'notices',
          component: notices
        },
        {
          path: '/mediaCenter',
          name: 'mediaCenter',
          component: mediaCenter
        },
        {
          path: '/mediaCenterPage',
          name: 'mediaCenterPage',
          component: mediaCenterPage
        },
        {
          path: '/report',
          name: 'report',
          component: report
        },
        {
          path:'/reportresult',
          name:'reportresult',
          component:reportresult
        },
      ]
    },
    {
      path:'/reportresultimg',
      name:'reportresultimg',
      component:reportresultimg
    },
    {
      path:'*',
      redirect:'/notfound'
    }
  ],
  scrollBehavior(to,from,savedPosition){
    if(savedPosition){
      return savedPosition;
    }else{
      return {x:0,y:0}
    }
  },

})



// WEBPACK FOOTER //
// ./src/router/index.js